import { auth } from "../firebase/config";

// The delete runs on the web app's server (it needs the Admin SDK to remove
// the sign-in account): apps/web/src/app/api/admin/delete-user/route.ts.
const DELETE_USER_URL =
  process.env.REACT_APP_DELETE_USER_URL || "https://soocher.in/api/admin/delete-user";

/**
 * Permanently delete a patient or doctor: sign-in account, profile, their
 * consultations, bookings, withdrawals and chat. Cannot be undone.
 * @returns {Promise<{success: boolean, deleted?: object, error?: string}>}
 */
export const deleteUserPermanently = async (uid) => {
  try {
    const token = await auth.currentUser?.getIdToken();
    if (!token) return { success: false, error: "You're signed out. Sign in again." };
    const res = await fetch(DELETE_USER_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ uid }),
    });
    const data = await res.json().catch(() => ({}));
    if (res.ok && data.success) return { success: true, deleted: data.deleted };
    const detail = data.errors?.length ? data.errors.join("\n") : data.error;
    return { success: false, deleted: data.deleted, error: detail || `Delete failed (${res.status}).` };
  } catch (error) {
    return { success: false, error: error.message };
  }
};
